/* Copyright Information: Created by BuyGroup */
import React from "react";
import {
  Button,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";

const DeleteCategory = (props) => {
  const {
    deleteCategoryModal,
    deleteCategoryId,
    removeCategory,
    closedCategoryModal,
    isLoadingButton,
  } = props;
  return (
    <div>
      <Modal isOpen={deleteCategoryModal} style={{ overlay: { opacity: 0.1 } }}>
        <ModalHeader toggle={closedCategoryModal}>
          <h5 className="modal-title f-w-600" id="exampleModalLabel2">
            Confirmation
          </h5>
        </ModalHeader>
        <ModalBody>
          <FormGroup className="form-group mb-3 row">
            <Label className="col-xl-12 col-sm-12 mb-0">
              Are you sure you want to delete this Category?
            </Label>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button
            type="submit"
            color="primary"
            onClick={() => removeCategory(deleteCategoryId)}
            disabled={isLoadingButton}
          >
            {isLoadingButton ? "Please Wait..." : "Yes, Delete it!"}
          </Button>
          <Button type="button" color="light" onClick={closedCategoryModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default DeleteCategory;
/* Copyright Information: Created by BuyGroup */
